import { useMutation } from '@tanstack/react-query';
import { apiService } from '../../services/api';

// STD-015: write-shaped actions for the shared-object read surface (#1205).
// apiService is imported here (a *.mutations.ts file) per STD-016.

/**
 * Presign a download for one object the caller may read.
 *
 * A mutation rather than a query despite being a GET, matching
 * `useGetDownloadUrlMutation` in `fileManagement.queries.ts`: the URL is minted
 * on demand, expires, and must never be cached and re-handed out later. It is
 * fetched because somebody clicked, not because a component mounted.
 *
 * Nothing is invalidated — reading a file changes no server state.
 *
 * The global toast is suppressed so the view can render the failure next to the
 * row that caused it. A shared object can stop being reachable between the
 * listing and the click (the owner revokes, or soft-deletes it), which comes
 * back as a 404 — that is a real answer about access, and it deserves to stay on
 * screen rather than flash past.
 */
export function useSharedObjectDownloadMutation() {
  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: async (objectId: string) => apiService.getObjectDownloadUrl(objectId),
  });
}
